import type { Budget } from '@subaio/api-types/budget'

type ReturnType = Record<
	string,
	{
		totalMonthlyAmountUserProvided: number | null
		totalMonthlyAmount: number
		amount: number
	}
>

export const collectCategories = (budget: Budget): ReturnType =>
	Object.fromEntries([
		...Object.values(budget.categories).flatMap((category) =>
			Object.values(category.categories).map((subcategory) => [
				subcategory.id,
				{
					totalMonthlyAmountUserProvided: subcategory.totalMonthlyAmountUserProvided,
					totalMonthlyAmount: Math.round(subcategory.totalMonthlyAmount),
					amount: subcategory.totalMonthlyAmountUserProvided ?? Math.round(subcategory.totalMonthlyAmount),
				},
			]),
		),
		...Object.values(budget.income).map((category) => [
			category.id,
			{
				totalMonthlyAmountUserProvided: category.totalMonthlyAmountUserProvided,
				totalMonthlyAmount: Math.round(category.totalMonthlyAmount),
				amount: category.totalMonthlyAmountUserProvided ?? Math.round(category.totalMonthlyAmount),
			},
		]),
	])
